import { useForm as createUseForm } from "@ant-design-vue/use";
import { Col, Modal, notification, Row } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import {
    createButton,
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../utils/button";
import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDelete,
    onClickDeleteAll,
    onClickEdit,
    onClickView,
    watchRulesChildren
} from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { has } from "../../../../utils/menu-context";
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionOpenUrl, createRowActionReStatus,
    createRowActionView
} from "../../../../utils/page";
import { flatWhereGroup } from "../../../../utils/search";
import { required, requiredWhen, validateError } from "../../../../utils/validate";
import { callHazSubStanceType } from "../../haz/request/haz-info/haz-info.section";
import { openModalForm as openModalFormConfirmApprove } from "../../storage-location/request/modal/confirm-approve.logic";
import { openModalForm as openModalFormConfirmReceive } from "../../storage-location/request/modal/confirm-receive.logic";
import { openModalForm as openModalFormConfirmRequest } from "../../storage-location/request/modal/confirm-request.logic";
import { callRequestDoc, callRequestStatus, callRequestType } from "../../storage-location/request/request.section";
import {
    callRequestDocGenType,
    callUser,
    callUserCompanyMe,
    checkUserCompanyOperation
} from "../../storage-location/request/requestor/requestor.section";
import { createForm as createFormHazDiscuss } from "../haz-discuss/haz-discuss.logic";
import { requiredSolidOrLiquid } from "../haz-discuss/haz-discuss.section";
import { callMainOperation as callRequestOperation } from "./haz-discuss-info/haz-discuss-info.section";
import { callPictogram } from "./haz-discuss-product/haz-discuss-product.section";
import { processResult } from "./modal/process.condition";
import {
    callHazDiscussDofControlNull,
    callHazDiscussResultNull,
    openModalForm as openModalFormProcess
} from "./modal/process.logic";
import { createConditionAction, createConditionForm } from "./request.condition";
import { callHazDiscussAttachment, createColumns, createField, isOperationAndSubStanceTypeMain } from "./request.section";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/request";

export const callRequest = ({ form }) => store.dispatch(`${actionPrefix}/request`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callReStatus = ({ data }) => store.dispatch(`${actionPrefix}/reStatus`, { data });
export const callReportHazDiscuss = ({ data }) => store.dispatch(`${actionPrefix}/reportHazDiscuss`, { data });
export const callRequestHazDiscuss = ({ data }) => store.dispatch(`${actionPrefix}/calculateHazDiscuss`, { data });
//export const callSaveHazDiscuss = ({ id }) => store.dispatch(`resource/v1/transaction/hazDiscuss/save`, { id })

export const onSearch = ({ props, page }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...where, ...createWhereFor({ props })], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const validate = ({ props, data, refs }) => {
    const { menuContext } = props;
    const rulesTop = createRulesTop({ props, data, refs });
    const rules1 = createRulesTab1({ props, data, refs });
    const rules2 = createRulesTab2({ props, data, refs });
    const rules3 = createRulesTab3({ props, data, refs });
    const rules4 = createRulesTab4({ props, data, refs });
    const rules5 = createRulesTab5({ props, data, refs });
    let tabKey = null;
    return data.useForm
        .validate(Object.keys(rulesTop))
        .then(() => {
            tabKey = "Requestor";
            return data.useForm.validate(Object.keys(rules1));
        })
        .then(() => {
            tabKey = "HazDiscussInfo";
            return data.useForm.validate(Object.keys(rules2));
        })
        .then(() => {
            tabKey = "HazDiscussProduct";
            return data.useForm.validate(Object.keys(rules3));
        })
        .then(() => {
            tabKey = "HazDiscussUseRate";
            return data.useForm.validate(Object.keys(rules4));
        })
        .then(() => {
            tabKey = "Attachment";
            return data.useForm.validate(Object.keys(rules5));
        })
        .catch(error => {
            if (tabKey) {
                menuContext.tabKey = tabKey;
            }
            validateError({ error });
            throw error;
        });
};

export const onClickSave = ({ props, data, refs, formParams, successText }) => {
    const { viewOnly, routerPrefix } = props;
    return validate({ props, data, refs }).then(() => {
        setIsLoadingApp(true);
        data.useForm.modelRef.refHazDiscussTemp?.mainSubStances?.filter(d => d.isDelete !== true)?.forEach(d => (d.isSave = true));
        return callRequest({ form: { ...data.useForm.modelRef, ...formParams } })
            .finally(() => setIsLoadingApp(false))
            .then(record => {
                if (successText) notification["success"]({ message: successText });
                if (viewOnly) initForm({ props, data, refs });
                else onClickView({ record, routerPrefix });
            });
    });
};

export const onClickProcessOffice = ({ props, data }) => {
        setIsLoadingApp(true)
        return callRequestHazDiscuss({ data: { ...data.useForm.modelRef } })
            .finally(() => setIsLoadingApp(false))
            .then(record => {
                data.useForm.modelRef.refHazDiscussTemp.refResult = record.result
                data.useForm.modelRef.refHazDiscussTemp?.mainSubStances?.forEach(items => {
                    record.mainSubStances.forEach(itemResp => {
                        if (items.id == itemResp.id){
                            items.refSubStanceProcess = itemResp.refSubStanceProcess
                            if (items.refSubStanceProcess?.refType?.key == 'media') {
                                items.dofControl = data.refDofControlNull.find(e => e.key == '5').value;
                            } else if (items.refSubStanceProcess?.refSpecies?.key == '1') {
                                items.dofControl = data.refDofControlNull.find(e => e.key == '1').value;
                            } else if (items.refSubStanceProcess?.refSpecies?.key == '2') {
                                items.dofControl = data.refDofControlNull.find(e => e.key == '2').value;
                            } else if (items.refSubStanceProcess?.refSpecies?.key == '3') {
                                items.dofControl = data.refDofControlNull.find(e => e.key == '3').value;
                            } else if (items.refSubStanceProcess?.refSpecies?.key == '4') {
                                items.dofControl = data.refDofControlNull.find(e => e.key == '4').value;
                            } else if (items.refSubStanceProcess == null) {
                                items.dofControl = data.refDofControlNull.find(e => e.key == '6').value;
                            }
                        }
                    })
                })

            }).then(() => openModalFormProcess({
                props,
                data,
            }))
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const onClickProcess = async ({ data, /*formParams*/ }) => {
    data = await processResult({ data });
    //data.useForm.modelRef.refHazDiscussTemp = callSaveHazDiscuss({ form: { ...data.useForm.modelRef.refHazDiscussTemp, ...formParams } });
    return data;
}

export const createSearchOneCriteria = ({ props, id, forLog }) => {
    if (!forLog) {
        return {
            select: ["**", "refHazDiscuss.id", "refHazDiscuss.approveCode", "refHazDiscuss.refUserCompany.*", "refHazDiscuss.refUserCompany.refPersonType.*", "refHazDiscussTemp.**", "refHazDiscussTemp.refUserCompany.**", "refHazDiscussTemp.refUser.**"],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }, ...createWhereFor({ props })],
            children: [
                {
                    name: "refHazDiscussTemp.refUserCompany.addresses",
                    select: ["*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                },
                {
                    name: "refHazDiscussTemp.refUser.addresses",
                    select: ["*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.draft",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "draft" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.waitReceive",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "waitReceive" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.waitApprove",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "waitApprove" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.approve",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.forRequestRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "in",
                            value: ["draft", "reEditOfficer", "reEditAuthority", "reEditCustoms"]
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.forReceiveRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "in",
                            value: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove"]
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: []
        };
    }
};

export const createWhereFor = ({ props }) => {
    const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    whereGroup.push([{ name: "createBy", type: "String", operator: "=", value: userInfo.username }]);
    if (has({ menuContext, key: "forRequest" })) {
        whereGroup.push([{ name: "refHazDiscussTemp.refUser.username", type: "String", operator: "=", value: userInfo.username }]);
        if (userInfo.isCeo) {
            whereGroup.push([{ name: "refHazDiscussTemp.refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id }]);
        }
    }
    if (has({ menuContext, key: "forReceive" })) {
        whereGroup.push([
            { name: "refStatus.key", type: "String", operator: "!=", value: "draft" },
            { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id }
        ]);
    }
    if (has({ menuContext, key: "forApprove" })) {
        whereGroup.push([{ name: "refToApproveBy.username", type: "String", operator: "=", value: userInfo.username }]);
    }
    if (has({ menuContext, key: "canViewAll" })) {
        whereGroup.push([{ name: "refStatus.key", type: "String", operator: "!=", value: "draft" }]);
    }
    return [
        { name: "refRequestDoc.key", type: "String", operator: "=", value: "01" },
        ...flatWhereGroup({ where: whereGroup, logic: "OR" })
    ];
};

export const createForm = () => {
    return {
        model: null,
        refModelId: null,
        refModelTempId: null,
        refRequestType: null,
        refRequestDoc: null,
        refStatus: null,
        draftCode: null,
        requestCode: null,
        refDepartment: null,
        isSignCa: null,
        refHazDiscuss: null,
        refHazDiscussTemp: { ...createFormHazDiscuss() },
        lastStatus: {
            draft: [{ remark: null, statusDatetime: null }],
            waitReceive: [{ remark: null, statusDatetime: null }],
            waitApprove: [{ remark: null, statusDatetime: null }],
            approve: [{ remark: null, statusDatetime: null }],
            forRequestRemark: [{ remark: null, statusDatetime: null }],
            forReceiveRemark: [{ remark: null, statusDatetime: null }]
        }
    };
};

export const createRules = ({ props, data, refs, key }) => {
    return {
        ...createRulesTop({ props, data, refs, key }),
        ...createRulesTab1({ props, data, refs, key }),
        ...createRulesTab2({ props, data, refs, key }),
        ...createRulesTab3({ props, data, refs, key }),
        ...createRulesTab4({ props, data, refs, key }),
        ...createRulesTab5({ props, data, refs, key })
    };
};

export const createRulesTop = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return {
        [`${prefix}refDocGenType`]: [required],
        [`${prefix}requestCode`]: [requiredWhen({ when: () => ["2"].includes(model.refDocGenType?.key) })],
        [`${prefix}refHazDiscussTemp.approveCode`]: [requiredWhen({ when: () => ["2"].includes(model.refDocGenType?.key) })],
        [`${prefix}refRequestType`]: [required],
        [`${prefix}refHazDiscuss`]: [requiredWhen({ when: () => ["2", "3", "4"].includes(model.refRequestType?.key) })],
        [`${prefix}refHazDiscussTemp.refMainOperation`]: [required],
        [`${prefix}lastStatus.forRequestRemark.0.remark`]: [requiredWhen({ when: () => !model.isOfficerCreate && ["2", "4"].includes(model.refRequestType?.key) && (!model.id || ["draft", "reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(model.refStatus?.key)) })]
    };
};

export const createRulesTab1 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return {
        [`${prefix}refDepartment`]: [required],
        [`${prefix}refHazDiscussTemp.refUserCompany`]: [
            requiredWhen({ when: () => true, requiredValidator: () => model.refHazDiscussTemp.refUserCompany?.id })
        ],
        [`${prefix}refHazDiscussTemp.refUser`]: [requiredWhen({ when: () => true, requiredValidator: () => model.refHazDiscussTemp.refUser?.id })]
    };
};

export const createRulesTab2 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refHazDiscussTemp.refMainOperation`]: [required],
        [`${prefix}refHazDiscussTemp.refSubOperation`]: [required],
        [`${prefix}refHazDiscussTemp.refMainObjective`]: [required],
        [`${prefix}refHazDiscussTemp.refSubObjective`]: [requiredWhen({
            when: () => model.refHazDiscussTemp?.refMainObjective?.key == "3"
        })],
        [`${prefix}refHazDiscussTemp.refManufactureCountry`]: [required],
        [`${prefix}refHazDiscussTemp.refDiscussTopic`]: [required],
        [`${prefix}refHazDiscussTemp.otherSubObjective`]: [requiredWhen({ 
            when: () => model.refHazDiscussTemp?.refSubObjective?.key == "3"
        })],
        [`${prefix}refHazDiscussTemp.otherDiscussTopic`]: [requiredWhen({ 
            when: () => model.refHazDiscussTemp?.refDiscussTopic?.key == "2"
        })],
        [`${prefix}refHazDiscussTemp.isOtherResult`]: [requiredWhen({ when: () => model.refStatus?.key === "waitReceive" && model.refHazDiscussTemp?.refDiscussTopic?.key == "2" })],
        [`${prefix}refHazDiscussTemp.otherResult`]: [requiredWhen({ when: () => model.refStatus?.key === "waitReceive" && model.refHazDiscussTemp?.isOtherResult === true })],
    };
    return rules;
};

export const createRulesTab3 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refHazDiscussTemp.tradeNameTh`]: [required],
        [`${prefix}refHazDiscussTemp.tradeNameEn`]: [required],
        [`${prefix}refHazDiscussTemp.isLiquid`]: [requiredSolidOrLiquid({ data, key })],
        [`${prefix}refHazDiscussTemp.manufacturer`]: [required],
        [`${prefix}refHazDiscussTemp.refCountry`]: [required],
        [`${prefix}refHazDiscussTemp.refToUse`]: [required],
        [`${prefix}refHazDiscussTemp.refSubStanceTypeMain`]: [required],
        [`${prefix}refHazDiscussTemp.otherToUse`]: [requiredWhen({ 
            when: () => {
                return model.refHazDiscussTemp?.refToUse?.key === '5' || model.refHazDiscussTemp?.refToUse?.value === 'อื่นๆ ระบุ';
            }
        })],
        [`${prefix}refHazDiscussTemp.mainSubStances`]: [required]
    };
    model?.refHazDiscussTemp?.mainSubStances?.forEach((item, index) => {
        rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.refSubStance`] = [required];
        rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.intense`] = [required];
        rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.microAnalysisQty1`] = [
            requiredWhen({
                when: () =>
                    true &&
                    (
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "2", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "5", subStanceTypeMain: "micro", isTechnicalGrade: false })
                    )
            })
        ];
        rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.microAnalysisQty2`] = [
            requiredWhen({
                when: () =>
                    true &&
                    (
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "2", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "5", subStanceTypeMain: "micro", isTechnicalGrade: false })
                    )
            })
        ];
        rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.microAnalysisQty3`] = [
            requiredWhen({
                when: () =>
                    true &&
                    (
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "2", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "5", subStanceTypeMain: "micro", isTechnicalGrade: false })
                    )
            })
        ];
        rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.refMicroUnit`] = [
            requiredWhen({
                when: () =>
                    true &&
                    (
                        isOperationAndSubStanceTypeMain({ modelRef, operation: "1", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "2", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "4", subStanceTypeMain: "micro", isTechnicalGrade: false })
                        || isOperationAndSubStanceTypeMain({ modelRef, operation: "5", subStanceTypeMain: "micro", isTechnicalGrade: false })
                    )
            })
        ];
        rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.otherSubStance`] = [
            requiredWhen({
                when: () =>
                    model.refHazDiscussTemp?.mainSubStances[`${index}`]?.refSubStance?.refType === null
            })
        ];
        /*rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.refLd50`] = [requiredWhen({ when: () => data.sendReceive })];
        rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.ld50Operator`] = [requiredWhen({ when: () => data.sendReceive })];
        rules[`${prefix}refHazDiscussTemp.mainSubStances.${index}.ld50Value`] = [requiredWhen({ when: () => data.sendReceive })];*/
        
    });
    model?.refHazDiscussTemp?.aquatics?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHazDiscussTemp.aquatics.${index}.refAquaticType`] = [required];
            rules[`${prefix}refHazDiscussTemp.aquatics.${index}.refSubAquaticType`] = [required];
            rules[`${prefix}refHazDiscussTemp.aquatics.${index}.qty`] = [required];
            rules[`${prefix}refHazDiscussTemp.aquatics.${index}.duration`] = [required];
            rules[`${prefix}refHazDiscussTemp.aquatics.${index}.refDurationUnit`] = [required];
        }
    });
    return rules;
};

export const createRulesTab4 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.refHazDiscussTemp?.useRates?.forEach((item, index) => {
        rules[`${prefix}refHazDiscussTemp.useRates.${index}.useRate`] = [required];
    });
    return rules;
};

export const createRulesTab5 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.refHazDiscussTemp?.attachments?.forEach((item, index) => {
        rules[`${prefix}refHazDiscussTemp.attachments.${index}.documentName`] = [required];
        rules[`${prefix}refHazDiscussTemp.attachments.${index}.size`] = [
            requiredWhen({ when: () => (model.refHazDiscussTemp.attachments[index].attribute?.isRequiredAttachment || model.refHazDiscussTemp.attachments[index].attribute?.documentNo) })
        ];
    });
    return rules;
};

export const createFormTitle = ({ data }) => {
    const modelRef = data.useForm.modelRef;
    return modelRef.id ? `${modelRef.refRequestDoc?.value} (${modelRef.refStatus?.value})` : i18n.global.t("button.create");
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, data, refs, id }) });
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ props, data }) => {
    const { form, forceDefault } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    const promises = [
        callRequestStatus({}),
        callRequestType({}),
        callRequestDoc({}),
        callRequestOperation({}),
        callPictogram({}),
        callHazSubStanceType({}),
        callHazDiscussAttachment({}),
        callRequestDocGenType({}),
        callHazDiscussResultNull({}),
        callHazDiscussDofControlNull({})
    ];
    return Promise.all(promises).then(arr => {
        data.statuses = arr[0];
        data.requestTypes = arr[1];
        data.requestDocs = arr[2];
        data.requestOperations = arr[3];
        data.pictograms = arr[4];
        data.hazSubStanceTypeMains = arr[5];
        data.hazDiscussAttachments = arr[6];
        data.requestDocGenTypes = arr[7];
        data.resultNull = arr[8];
        data.refDofControlNull = arr[9];
        const userInfo = store.state.resource.auth.info?.user;

        if ((!id && !form) || forceDefault) {
            modelRef.isOfficerCreate = !!userInfo.refOfficerLv;
            if (!modelRef.isOfficerCreate) {
                callUserCompanyMe({}).then(userCompanies => {
                    const refUserCompany = userCompanies[0];
                    modelRef.refHazDiscussTemp.refUserCompany = refUserCompany;
                    if (refUserCompany) {
                        callUser({ userCompanyId: refUserCompany.id }).then(
                            users => (modelRef.refHazDiscussTemp.refUser = users.find(d => d.id === store.state.resource.auth.info?.user?.id))
                        );
                        modelRef.refHazDiscussTemp.refMainOperation = checkUserCompanyOperation({
                            operations: data.requestOperations,
                            userCompany: refUserCompany
                        })[0];
                    }
                });
            }
            modelRef.refHazDiscussTemp.refUser = store.state.resource.auth.info?.user;
            modelRef.lastStatus.draft[0].statusDatetime = moment().format("YYYY-MM-DD[T]HH:mm:ssZ");
            data.hazDiscussAttachments.forEach(item =>
                modelRef.refHazDiscussTemp.attachments.push({ documentName: item.value, attribute: lodash.cloneDeep(item.attribute) })
            );
            modelRef.refRequestType = data.requestTypes.find(d => d.key === "1");
            modelRef.refRequestDoc = data.requestDocs.find(d => d.key === "01");
            modelRef.refHazDiscussTemp.refMainOperation = data.requestOperations.find(d => d.key === "1");
            modelRef.refHazDiscussTemp.refSubStanceTypeMain = data.hazSubStanceTypeMains.find(d => d.key === "chemi")
            modelRef.refDocGenType = data.requestDocGenTypes.find(d => d.key === "1");
            modelRef.refHazDiscussTemp.isTechnicalGrade = false;
        }
    });
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canArchive({ props, record }) })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canDelete({ props, record }) })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record })
        }),
        createRowActionReStatus({
            menuContext,
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.reStatus") }),
                    autoFocusButton: "cancel",
                    onOk: () => {
                        setIsLoadingApp(true);
                        callReStatus({ data: record })
                            .finally(() => setIsLoadingApp(false))
                            .then(() => onSearch({ props, page: state.page }));
                    }
                });
            },
            visible: ({ record }) => state.conditionAction.canReStatus({ props, record })
        }),
        /*
        createRowActionPdf({
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="search.svg"></CIcon> },
            text: () => i18n.global.t("button.viewRequestDocument"),
            callReport: ({ record }) => callReportHazDiscuss({ data: { id: record.id } }),
            fileName: "report.pdf"
        })
        */
        createRowActionOpenUrl({
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="search.svg"></CIcon> },
            text: () => i18n.global.t("button.viewRequestDocument"),
            callUrl: ({ record }) => `${process.env.VUE_APP_API_REPORT_URL}/files/haz/company/${record.id}/file-result.pdf?contentDisposition=inline&_timestamp=${new Date().getTime()}`,
            visible: ({ record }) => state.conditionAction.canReport({ props, record })
        })
    ];
};

export const initForm = ({ props, data, refs }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    data.userInfo = store.state.resource.auth.info?.user;
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHazDiscussTemp.mainSubStances.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab3({ props, data, refs }),
        itemsKey: "refHazDiscussTemp.mainSubStances"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHazDiscussTemp.aquatics.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab3({ props, data, refs }),
        itemsKey: "refHazDiscussTemp.aquatics"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHazDiscussTemp.useRates.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab4({ props, data, refs }),
        itemsKey: "refHazDiscussTemp.useRates"
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHazDiscussTemp.attachments.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab5({ props, data, refs }),
        itemsKey: "refHazDiscussTemp.attachments"
    });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                    default: () => createAppPageHeaderDefault({ props, data, refs })
                }
            });
        }
    });
};

export const createAppPageHeaderDefault = ({ props, data, refs }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    const canWaitReceive = state.conditionAction.canWaitReceive({ props, record: initialModel });
    const canWaitApprove = state.conditionAction.canWaitApprove({ props, record: initialModel });
    const canApprove = state.conditionAction.canApprove({ props, record: initialModel });
    const canDelete = state.conditionAction.canDelete({ props, record: initialModel });
    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive && canEdit))) {
        col1.push(
            createButtonSave({
                onClick: () => {
                    data.sendReceive = false;
                    const refHazDiscussTemp = modelRef.refHazDiscussTemp;
                    let statusRemark = null;
                    if ([undefined, "draft", "reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forRequestRemark[0].remark;
                    } else if (["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forReceiveRemark[0].remark;
                    }
                    onClickSave({
                        props,
                        data,
                        refs,
                        formParams: {
                            refHazDiscussTemp: {
                                ...modelRef.refHazDiscussTemp,
                                refUserCompany: refHazDiscussTemp?.refUserCompany?.id ? refHazDiscussTemp?.refUserCompany : null,
                                refUser: refHazDiscussTemp?.refUser?.id ? refHazDiscussTemp?.refUser : null
                            },
                            statusRemark
                        }
                    });
                },
                classStyle: "m-1"
            })
        );
    }
    if (id && isActive && canWaitReceive) {
        const statusWaitReceive = data.statuses.find(status => status.key === "waitReceive");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${statusWaitReceive?.attribute?.actionText}`,
                classStyle: `m-1 ${statusWaitReceive?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmRequest({
                            onOk: record => {
                                const refHazDiscussTemp = modelRef.refHazDiscussTemp;
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    formParams: {
                                        refHazDiscussTemp: {
                                            ...modelRef.refHazDiscussTemp,
                                            refUserCompany: refHazDiscussTemp?.refUserCompany?.id ? refHazDiscussTemp?.refUserCompany : null,
                                            refUser: refHazDiscussTemp?.refUser?.id ? refHazDiscussTemp?.refUser : null
                                        },
                                        statusRemark: modelRef.lastStatus.forReceiveRemark[0].remark,
                                        statusRemarkBefore: modelRef.lastStatus.forRequestRemark[0].remark,
                                        refStatus: statusWaitReceive,
                                        isSignCa: record.isSignCa,
                                        passwordCa: record.passwordCa
                                    },
                                    successText: i18n.global.t("views.request.modal.request.sendSuccess")
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    if (id && isActive && canWaitApprove) {
        const statusWaitApprove = data.statuses.find(status => status.key === "waitApprove");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${i18n.global.t("button.sendRequest")}`,
                classStyle: `m-1 ${statusWaitApprove?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmReceive({
                            props: {
                                roleName: "HAZ_DISCUSS_APPROVE",
                                statusKeys: ["draft"].includes(initialModel.refStatus?.key) ? ["waitApprove"] : [],
                                statusDisabledKeys: !modelRef.refHazDiscussTemp?.refResult ? ["waitApprove"] : [],
                                remark: !modelRef.refHazDiscussTemp?.refResult ? i18n.global.t("views.request.hazDiscuss.error.process2") : null
                            },
                            onOk: record => {
                                const refHazDiscussTemp = modelRef.refHazDiscussTemp;
                                const isStatusBack = ["reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(record.refStatus?.key);
                                if (!isStatusBack && ![undefined, "draft"].includes(modelRef.refStatus?.key) && refHazDiscussTemp.refResult === null) {
                                    notification["error"]({ message: i18n.global.t("views.request.hazDiscuss.error.process") })
                                    return;
                                } else {
                                    onClickSave({
                                        props,
                                        data,
                                        refs,
                                        formParams: {
                                            statusRemark: isStatusBack
                                                ? modelRef.lastStatus.forRequestRemark[0].remark
                                                : modelRef.lastStatus.forReceiveRemark[0].remark,
                                            statusRemarkBefore: isStatusBack
                                                ? modelRef.lastStatus.forReceiveRemark[0].remark
                                                : null,
                                            refStatus: record.refStatus,
                                            refToApproveBy: record.refToApproveBy
                                        },
                                        successText: i18n.global.t(`views.request.modal.receive.${record.refStatus?.key}`)
                                    });
                                }
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
        //Process button
        col2.push(
            createButton({
                text: i18n.global.t("button.process"),
                classStyle: `m-1 ${statusWaitApprove?.attribute?.btnClass}`,
                onClick: () => onClickProcessOffice({ data, formParams: { refHazDiscussTemp: modelRef.refHazDiscussTemp} })

            })
        );
    }
    if (id && isActive && canApprove) {
        const statusApprove = data.statuses.find(status => status.key === "approve");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${i18n.global.t("button.sendRequest")}`,
                classStyle: `m-1 ${statusApprove?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmApprove({
                            onOk: record => {
                                const isStatusBack = ["reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(record.refStatus?.key);
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    formParams: {
                                        statusRemark: isStatusBack
                                            ? modelRef.lastStatus.forRequestRemark[0].remark
                                            : modelRef.lastStatus.forReceiveRemark[0].remark,
                                        statusRemarkBefore: isStatusBack
                                            ? modelRef.lastStatus.forReceiveRemark[0].remark
                                            : null,
                                        refStatus: record.refStatus
                                    },
                                    successText: i18n.global.t(`views.request.modal.approve.${record.refStatus?.key}`)
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: "canActive" })) {
        col2.push(
            createButtonActive({
                onClick: () =>
                    onClickActive({
                        record: { id },
                        callActive,
                        setIsLoading: setIsLoadingApp,
                        onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canArchive" })) {
        col2.push(
            createButtonArchive({
                onClick: () =>
                    onClickArchive({
                        record: { id },
                        callArchive,
                        setIsLoading: setIsLoadingApp,
                        onClickView: () => onClickView({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && canDelete) {
        col2.push(
            createButtonDelete({
                onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }),
                classStyle: "m-1"
            })
        );
    }
    return (
        <Row type="flex">
            <Col>{col1}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const state = reactive({
    columns: createColumns(),
    page: createPage({
        options: {
            select: [
                "*",
                "refHazDiscuss.*",
                "refHazDiscussTemp.*",
                "refHazDiscussTemp.refUserCompany.*",
                "refHazDiscussTemp.refUserCompany.refPersonType.*",
                "refHazDiscussTemp.refUser.*",
                "refHazDiscussTemp.refMainOperation.*",
                "refRequestType.*",
                "refStatus.*",
                "refWaitReceiveStatus.*","refWaitReceiveStatus.*",
            ],
            sort: [/* { name: "refStatus.seq", type: "ASC" } ,*/{ name: "updateDate", type: "DESC" }]
        }
    }),
    tableOptions: { search: { activeKey: "Search" } },
    conditionAction: createConditionAction()
});
